import React, { FC } from 'react';
import cls from 'classnames';
import { ButtonImageProps } from './ButtonImage.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { Image } from '@stashinvest/react-assets';

export const classNames = getClassNames('sds-button-image', [
	'button-image',
]);

const ButtonImage: FC<ButtonImageProps> = (props) => {
	const {	imageToken, isEnabled=true, altText, onClick, label} = props

	return (
	<button 
		className={cls(getRootClassListFromProps(classNames, props))}
		disabled={!isEnabled}
		onClick={onClick}
		title={altText}
		aria-label={label}
	>
		<Image 
			className={classNames.buttonImage}
			imageToken={imageToken}
			size="medium"
		/>
	</button>)
};

ButtonImage.displayName = 'ButtonImage';

export default ButtonImage;
